module.exports = __webpack_public_path__ + "media/components/assets/images/sseobolgga/image9_2-a66d5b34cb9df30d7dc22cac428f7001.png";